import { z } from 'zod';

/**
 * COMMON API SCHEMAS
 * Shared primitives used across all API response schemas.
 */

export const resilientDateSchema = z
  .union([z.string(), z.date()])
  .nullable()
  .optional()
  .transform((val) => {
    if (!val) return new Date(0).toISOString();
    if (val instanceof Date) return val.toISOString();
    const d = new Date(val);
    return isNaN(d.getTime()) ? new Date(0).toISOString() : d.toISOString();
  })
  .default(new Date(0).toISOString());

export const dateSchema = resilientDateSchema;

export const optionalDateSchema = z
  .union([z.string(), z.date()])
  .nullable()
  .optional()
  .transform((val) => {
    if (!val) return undefined;
    if (val instanceof Date) return val.toISOString();
    const d = new Date(val);
    return isNaN(d.getTime()) ? undefined : d.toISOString();
  });

export const idSchema = z
  .union([z.string(), z.number()])
  .nullable()
  .optional()
  .transform((val) => (val === null || val === undefined ? '' : String(val)))
  .default('');

export const stringSchema = z
  .string()
  .nullable()
  .optional()
  .transform((val) => val ?? '')
  .default('');

export const booleanSchema = z
  .union([z.boolean(), z.string(), z.number()])
  .nullable()
  .optional()
  .transform((val) => {
    if (typeof val === 'string') return val.toLowerCase() === 'true' || val === '1';
    return !!val;
  })
  .default(false);

export const numberSchema = z
  .union([z.number(), z.string()])
  .nullable()
  .optional()
  .transform((val) => {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return val;
    const parsed = Number(val);
    return isNaN(parsed) ? 0 : parsed;
  })
  .default(0);

export const emailSchema = z
  .string()
  .email()
  .or(z.string().length(0))
  .nullable()
  .optional()
  .transform((val) => val ?? '');

export const urlSchema = z
  .string()
  .nullable()
  .optional()
  .transform((val) => val ?? '')
  .default('');
